import React from "react";
import FilerobotImageEditor, {
  TABS,
  TOOLS,
} from "react-filerobot-image-editor";

const EditorSuit = ({
  setEnableImageEditor,
  file,
  setOnFileContentChanges,
}) => {
  return (
    <React.Fragment>
      <FilerobotImageEditor
        source={file?.fileContent}
        defaultSavedImageName={`edited_${file.fileName}`}
        defaultSavedImageType="png"
        onSave={(editedImageObject, designState) => {
          setOnFileContentChanges(editedImageObject?.imageBase64);
          setEnableImageEditor(false);
        }}
        onClose={() => {
          setEnableImageEditor(false);
        }}
        annotationsCommon={{
          fill: "#FF0000",
        }}
        Text={{ text: "sample" }}
        Rotate={{ angle: 90, componentType: "slider" }}
        Crop={{
          presetsItems: [
            {
              titleKey: "classicTv",
              descriptionKey: "4:3",
              ratio: 4 / 3,
              // icon: CropClassicTv, // optional, CropClassicTv is a React Function component. Possible (React Function component, string or HTML Element)
            },
            {
              titleKey: "cinemascope",
              descriptionKey: "21:9",
              ratio: 21 / 9,
              // icon: CropCinemaScope, // optional, CropCinemaScope is a React Function component.  Possible (React Function component, string or HTML Element)
            },
          ],
        }}
      />
    </React.Fragment>
  );
};

export default EditorSuit;
